const getLanguage = () => localStorage.getItem('selectedLocale') || 'tr';
export default getLanguage;
